module.exports = __webpack_public_path__ + "static/media/lyk.d506c655.png";